import { styled } from 'linaria/react'

export const Header = styled.h1`
  color: var(--color-point);
  line-height: 1.2;
  max-width: 90%;
`